import {
  GET_ALL_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS_ERROR,
  GET_ALL_NOTIFICATIONS_SUCCESS,
  UPDATE_NOTIFICATION_READ,
} from './constants';

export const getAllUserNotifications = (userEmail) => {
  return {
    type: GET_ALL_NOTIFICATIONS,
    userEmail,
  };
};

export const getAllNotificationsSuccess = (payload) => {
  return {
    type: GET_ALL_NOTIFICATIONS_SUCCESS,
    payload,
  };
};

export const getAllNotificationsError = (error) => {
  return {
    type: GET_ALL_NOTIFICATIONS_ERROR,
    payload: error,
  };
};

export const updateNotificationRead = (notificationId) => {
  return {
    type: UPDATE_NOTIFICATION_READ,
    payload: notificationId,
  };
};
